import { jsx } from "react/jsx-runtime";
import "react";
import { createRoot } from "react-dom/client";
import analytics from "../../analytics/analytics.js";
import { MapPinElement } from "./MapPinElement.js";
const createMapAdvancedMarkerElement = (options)=>{
    const { gMap, AdvancedMarkerElement, pinDetails, seti } = options;
    if (!pinDetails.lat || !pinDetails.lng) return null;
    const lat = Number(pinDetails.lat);
    const lng = Number(pinDetails.lng);
    if (isNaN(lat) || isNaN(lng)) return null;
    const latLng = {
        lat,
        lng
    };
    const pinContainer = document.createElement('div');
    let pinReactRoot = null;
    try {
        let markerDOM = new AdvancedMarkerElement({
            content: pinContainer,
            map: gMap,
            position: latLng,
            gmpClickable: true
        });
        pinReactRoot = createRoot(pinContainer);
        pinReactRoot.render(/*#__PURE__*/ jsx(MapPinElement, {
            markerDOM: markerDOM,
            seti: seti,
            ...pinDetails
        }));
        return {
            marker: markerDOM,
            root: pinReactRoot
        };
    } catch (e) {
        pinReactRoot?.unmount();
        analytics.logError({
            loggedFrom: 'MapPinElement',
            message: 'MAP_EVENT_ERROR',
            errorMessage: e?.message
        });
    }
    return null;
};
export { createMapAdvancedMarkerElement };
